import { useUserStore } from '@/stores/user'
import { watch } from 'vue'

// const importMetaUrl = new URL(import.meta.url)
const importMetaUrl = new URL(import.meta.env.VITE_BACK_API)
console.log('importMetaUrl', importMetaUrl)
const socketProtocol = importMetaUrl.protocol === 'https:' ? 'wss' : 'ws'
const socketHost = `${importMetaUrl.hostname}:${importMetaUrl.port}`

let ws: WebSocket
let reconnectAttempts = 0
const maxReconnectAttempts = 10
let reconnectTimeout: number | null = null
let heartbeatInterval: number | null = null

function connect() {
  // Clear any existing reconnection timeout
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout)
    reconnectTimeout = null
  }

  const userStore = useUserStore()

  const token = userStore.sessionToken.token
  if (!token) return
  ws = new WebSocket(`${socketProtocol}://${socketHost}/ws`)

  console.log('[WS] Connecting to WebSocket server...', `${socketProtocol}://${socketHost}`)

  ws.onopen = () => {
    console.log('[WS] Connected to server')

    ws.send('token:' + token)
    // 开启心跳检测，保持连接活跃，避免被关闭
    startHeartbeat()
  }

  ws.onmessage = (event) => {
    console.log('event', event)
    handleMessage(event.data)
  }

  ws.onclose = () => {
    console.log('[WS] Disconnected from server. Reconnecting...')
    reconnect()
  }

  ws.onerror = (err) => {
    // console.error('[WS] Error occurred:', err)
    // Note: The 'close' event will be fired after 'error', so we don't need to reconnect here
    console.error('[WS] Connection error:', {
      url: ws.url,
      readyState: ws.readyState,
      details: err
    })
  }
}

function startHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval)
  }
  heartbeatInterval = setInterval(function () {
    if (ws.readyState == ws.OPEN) {
      ws.send('PING')
    } else {
      console.log('[WS] Connection not open. Not sending PING.')
      heartbeatInterval && clearInterval(heartbeatInterval)
    }
  }, 60 * 1000) //60秒一次心跳包
}

function reconnect() {
  if (reconnectAttempts < maxReconnectAttempts) {
    const delay = Math.min(1000 * 2 ** reconnectAttempts, 10000)
    console.log(`[WS] Attempting to reconnect in ${delay}ms (attempt ${reconnectAttempts + 1}/${maxReconnectAttempts})`)

    reconnectTimeout = setTimeout(() => {
      reconnectAttempts++
      connect()
    }, delay)
  } else {
    console.error('[WS] Max reconnect attempts reached.')
  }
}

function handleMessage(payload: any) {
  // } else if (res.data == 'updateUnReadMsgNum') {
  console.log('[WS] payload:', payload)
  switch (payload) {
    case 'updateUnReadMsgNum':
      const userStore = useUserStore()
      userStore.fetchUserNewMessageCount()
      break
    case 'reload':
      window.location.reload()
      break
    case 'PONG':
      console.log('[WS] Received PONG. Connection is still active.')
      reconnectAttempts = 0 // Reset reconnect attempts on successful connection
      break
  }
}

// Optionally expose for manual reconnection
;(window as any).reconnectWebSocket = () => {
  if (ws) {
    ws.close() // This will trigger the reconnection flow
  } else {
    connect()
  }
}

function initWebsocket() {
  const userStore = useUserStore()
  watch(
    () => userStore.sessionToken.token,
    (nd, od) => {
      console.log('[WS] sessionToken.token changed', nd, od)
      nd && connect()
    },
    { immediate: true }
  )
  watch(
    () => userStore.logout,
    (nd, od) => {
      console.log('[WS] logout', nd, od)
      nd && ws && ws.close()
    },
    { immediate: true }
  )
}

export { initWebsocket }
